/* eslint-disable react-hooks/exhaustive-deps */
import {useCallback, useState} from 'react'

import {useIsomorphicLayoutEffect} from '@s-ui/react-hooks'

const useNotificationManager = ({key: cookieKey}) => {
  const [showNotification, setShowNotification] = useState(false)

  useIsomorphicLayoutEffect(() => getIsNeededToShowNotification(), [])

  const getIsNeededToShowNotification = useCallback(() => {
    const notificationCookie = localStorage.getItem(cookieKey)

    const isViewedNotification = Boolean(notificationCookie)

    const isNeededToShowNotification = !isViewedNotification

    isNeededToShowNotification && setShowNotification(true)
  }, [])

  const setIsViewedNotification = useCallback(() => {
    localStorage.setItem(cookieKey, true)
    setShowNotification(false)
  }, [])

  return {
    showNotification,
    setIsViewed: setIsViewedNotification
  }
}

export {useNotificationManager}
